import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { getRedirectPathByRole } from '@/utils'
import { getCurrentRole, isAuthenticated } from '@/utils/auth'
import { useTranslation } from 'react-i18next'

export function PublicRoute() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const role = getCurrentRole()
  const isLoggedIn = isAuthenticated()

  useEffect(() => {
    if (isLoggedIn) {
      const targetPath = getRedirectPathByRole()
      navigate(targetPath, { replace: true })
    }
  }, [isLoggedIn, navigate, role])

  if (isLoggedIn) {
    return <div>{t('Navigating...' as any)}</div>
  }

  return <Outlet />
}
